// RootReducer - here we combine ALL the reducers
import { i18nReducer } from 'react-redux-i18n';
import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import * as ducks from './index';

const rootReducer = combineReducers({
  ...ducks,
  i18n: i18nReducer,
  routing: routerReducer,
  form: reduxFormReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/ducks/rootReducer.js